import '../../App.scss';
import ItemListContainer from './listedItems/itemListContainer';
import CityProfitsHeader from './cityProfitsHeader/cityProfitsHeader';
import useCityProfitsLogic from './cityProfitsLogic';
import '../../style/cityProfits.scss'

function CityProfits() {
  const { itemsSelected, setItemsSelected } = useCityProfitsLogic();

  return (
    <>
      <CityProfitsHeader
        itemsSelected={itemsSelected}
        setItemsSelected={setItemsSelected}
      />
      {itemsSelected.length !== 0 && (
        <ItemListContainer
          setItemsSelected={setItemsSelected}
          listItemsSelected={itemsSelected}
        />
      )}
      <div className='cityProfitsFooter'>The data for this app is provided by the Albion Data Project.</div>
    </>
  );
}

export default CityProfits;
